import React from 'react'
import { Grid2,Paper,Typography } from '@mui/material'
import AllSpices from "../../../assets/Home/AboutusHero2.jpg"

export function AboutInfo() {
  return (
    <Grid2  className="Transfercontainer">
      <Grid2 className="basecontainer" sx={{width:"100% !important",flexDirection:"column"}}>
        <Grid2  className="imagecontainer" width="90% !important">
          <img component={Paper} width="100% !important" style={{borderRadius:"10px"}} src={AllSpices} alt="" />
        </Grid2>
        <Grid2 className="textcontainer" width="90%  !important" alignItems="center" >
          <Typography className="infoheading" fontSize="20px !important" textAlign="center" width="90% !important" margin="10px 0px !important">WELCOME TO GBG EXPORTS</Typography>
          <Typography className="infotext" >
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Vel, officiis eaque. Voluptate quibusdam, ducimus neque Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae, doloremque. Veniam provident id at aspernatur eius vel totam dolores saepe nobis nisi quia, libero labore! Facere quam non illum ducimus. magni, provident sed voluptate! Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae pariatur quidem, voluptas quaerat earum explicabo asperiores doloremque? Consequuntur molestiae necessitatibus perspiciatis itaque, consequatur quibusdam sed saepe ullam molestias, optio omnis!
          </Typography>
        </Grid2>
      </Grid2>
    </Grid2>
  )
}

 